// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zY5oC","placeholdersHeader":"styles_placeholdersHeader__34Elg","editorStyle":"styles_editorStyle__3IWhJ","placeholdersBox":"styles_placeholdersBox__QPrvF"};